import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-member-change-log', {
  mixins: [eventListenerMixin],

  connected() {
    this.listenTo(this, 'click', this.handleLinkMoreClick.bind(this));
  },

  disconnected() {
    this.stopListening();
  },

  handleLinkMoreClick(event) {
    const linkMore = closest(event.target, '.link-logs-more');
    if (linkMore) {
      Array.prototype.forEach.call(
        this.querySelectorAll('.log-item.hide'),
        item => item.classList.remove('hide'),
      );
      linkMore.remove();
    }
  },
});
